import NotImplementedException from '../exceptions/NotImplementedException';
import BaseSchema from './schema';

function getSchema(name) {
  const schema = BaseSchema[name];
  if (!schema) {
    throw new NotImplementedException('getSchema must be implemented');
  }
  return schema;
}

export default { getSchema };
